// Public car-routing reference, not a certified shuttle operating route.
// Preserve all provider coordinates; canonical boarding stops remain unchanged.
export const GANGNAM_ROAD_REFERENCE = Object.freeze({
  "provider": "OSRM/FOSSGIS",
  "dataset": "OpenStreetMap",
  "profile": "car",
  "purpose": "road_reference",
  "license": "ODbL-1.0",
  "licenseUrl": "https://www.openstreetmap.org/copyright",
  "providerUrl": "https://routing.openstreetmap.de/about.html",
  "sourceUrl": "https://routing.openstreetmap.de/routed-car/route/v1/driving/127.02771,37.497303;126.97701,37.210081?overview=full&geometries=geojson&steps=false&alternatives=false&radiuses=20;20",
  "retrievedAt": "2026-10-11T02:53:42.942Z",
  "geometrySha256": "241e9c819caf575dc619531aeda8f19c63c3a3633980cfc754772d0efb2a62df",
  "rawResponseSha256": "749513a99eb3144b400d66695c575233800986a1d994677ff8b935a66426947a",
  "operatingRouteCertification": "NOT_TESTED",
  "inputStops": [
    {
      "id": "gangnam-station",
      "lat": 37.497303,
      "lng": 127.02771
    },
    {
      "id": "campus-sh",
      "lat": 37.210081,
      "lng": 126.97701
    }
  ],
  "endpointDisplacementMeters": [
    7.231056259,
    9.648898782
  ]
})

const trustedMetadataJson = JSON.stringify(GANGNAM_ROAD_REFERENCE)

export function isVerifiedGangnamRoadReference(reference) {
  return Boolean(reference && JSON.stringify(reference) === trustedMetadataJson)
}

export function hasVerifiedGangnamRoadGeometry(points, reference) {
  return isVerifiedGangnamRoadReference(reference) && Array.isArray(points)
    && points.length === GANGNAM_ROAD_PATH.length
    && points.every((point, index) => point?.lat === GANGNAM_ROAD_PATH[index].lat && point?.lng === GANGNAM_ROAD_PATH[index].lng)
}

export const GANGNAM_ROAD_PATH = [
  {
    "lat": 37.497327,
    "lng": 127.027786
  },
  {
    "lat": 37.497065,
    "lng": 127.027915
  },
  {
    "lat": 37.496691,
    "lng": 127.028099
  },
  {
    "lat": 37.496284,
    "lng": 127.028293
  },
  {
    "lat": 37.495567,
    "lng": 127.028637
  },
  {
    "lat": 37.495147,
    "lng": 127.028861
  },
  {
    "lat": 37.494943,
    "lng": 127.028948
  },
  {
    "lat": 37.494646,
    "lng": 127.029068
  },
  {
    "lat": 37.493211,
    "lng": 127.0298
  },
  {
    "lat": 37.493007,
    "lng": 127.029908
  },
  {
    "lat": 37.492824,
    "lng": 127.029985
  },
  {
    "lat": 37.49153,
    "lng": 127.030585
  },
  {
    "lat": 37.491421,
    "lng": 127.030633
  },
  {
    "lat": 37.490998,
    "lng": 127.030843
  },
  {
    "lat": 37.490061,
    "lng": 127.031274
  },
  {
    "lat": 37.489709,
    "lng": 127.03146
  },
  {
    "lat": 37.489545,
    "lng": 127.031533
  },
  {
    "lat": 37.489324,
    "lng": 127.031622
  },
  {
    "lat": 37.488984,
    "lng": 127.031797
  },
  {
    "lat": 37.488824,
    "lng": 127.031869
  },
  {
    "lat": 37.488376,
    "lng": 127.032039
  },
  {
    "lat": 37.487791,
    "lng": 127.032329
  },
  {
    "lat": 37.487428,
    "lng": 127.032508
  },
  {
    "lat": 37.487313,
    "lng": 127.032567
  },
  {
    "lat": 37.48677,
    "lng": 127.032847
  },
  {
    "lat": 37.4866,
    "lng": 127.032948
  },
  {
    "lat": 37.486409,
    "lng": 127.033042
  },
  {
    "lat": 37.485931,
    "lng": 127.033266
  },
  {
    "lat": 37.485401,
    "lng": 127.033501
  },
  {
    "lat": 37.485078,
    "lng": 127.033653
  },
  {
    "lat": 37.484794,
    "lng": 127.033796
  },
  {
    "lat": 37.484678,
    "lng": 127.033855
  },
  {
    "lat": 37.484538,
    "lng": 127.033954
  },
  {
    "lat": 37.484385,
    "lng": 127.034077
  },
  {
    "lat": 37.484096,
    "lng": 127.034299
  },
  {
    "lat": 37.48394,
    "lng": 127.034456
  },
  {
    "lat": 37.483778,
    "lng": 127.034621
  },
  {
    "lat": 37.483285,
    "lng": 127.035127
  },
  {
    "lat": 37.482474,
    "lng": 127.035983
  },
  {
    "lat": 37.482328,
    "lng": 127.036141
  },
  {
    "lat": 37.482057,
    "lng": 127.036416
  },
  {
    "lat": 37.48176,
    "lng": 127.03673
  },
  {
    "lat": 37.481498,
    "lng": 127.036979
  },
  {
    "lat": 37.481237,
    "lng": 127.037233
  },
  {
    "lat": 37.481108,
    "lng": 127.037356
  },
  {
    "lat": 37.481002,
    "lng": 127.037448
  },
  {
    "lat": 37.480941,
    "lng": 127.037495
  },
  {
    "lat": 37.480881,
    "lng": 127.037541
  },
  {
    "lat": 37.480745,
    "lng": 127.037635
  },
  {
    "lat": 37.480585,
    "lng": 127.037734
  },
  {
    "lat": 37.480412,
    "lng": 127.03782
  },
  {
    "lat": 37.480219,
    "lng": 127.037914
  },
  {
    "lat": 37.480035,
    "lng": 127.037993
  },
  {
    "lat": 37.479529,
    "lng": 127.038193
  },
  {
    "lat": 37.479372,
    "lng": 127.038241
  },
  {
    "lat": 37.479198,
    "lng": 127.038299
  },
  {
    "lat": 37.478995,
    "lng": 127.038361
  },
  {
    "lat": 37.478641,
    "lng": 127.038418
  },
  {
    "lat": 37.478322,
    "lng": 127.038499
  },
  {
    "lat": 37.478104,
    "lng": 127.038563
  },
  {
    "lat": 37.477889,
    "lng": 127.038565
  },
  {
    "lat": 37.477027,
    "lng": 127.038574
  },
  {
    "lat": 37.476732,
    "lng": 127.038566
  },
  {
    "lat": 37.475536,
    "lng": 127.038574
  },
  {
    "lat": 37.475157,
    "lng": 127.038566
  },
  {
    "lat": 37.473897,
    "lng": 127.038561
  },
  {
    "lat": 37.47364,
    "lng": 127.03855
  },
  {
    "lat": 37.473456,
    "lng": 127.038552
  },
  {
    "lat": 37.473165,
    "lng": 127.038544
  },
  {
    "lat": 37.473133,
    "lng": 127.038543
  },
  {
    "lat": 37.472962,
    "lng": 127.038538
  },
  {
    "lat": 37.472762,
    "lng": 127.038532
  },
  {
    "lat": 37.472476,
    "lng": 127.038528
  },
  {
    "lat": 37.472126,
    "lng": 127.038553
  },
  {
    "lat": 37.471676,
    "lng": 127.03855
  },
  {
    "lat": 37.47145,
    "lng": 127.038555
  },
  {
    "lat": 37.47124,
    "lng": 127.038572
  },
  {
    "lat": 37.471174,
    "lng": 127.038577
  },
  {
    "lat": 37.470999,
    "lng": 127.038593
  },
  {
    "lat": 37.470809,
    "lng": 127.038627
  },
  {
    "lat": 37.470643,
    "lng": 127.038668
  },
  {
    "lat": 37.470582,
    "lng": 127.038684
  },
  {
    "lat": 37.470381,
    "lng": 127.038736
  },
  {
    "lat": 37.469966,
    "lng": 127.03891
  },
  {
    "lat": 37.469696,
    "lng": 127.039032
  },
  {
    "lat": 37.469428,
    "lng": 127.039167
  },
  {
    "lat": 37.46922,
    "lng": 127.039279
  },
  {
    "lat": 37.469029,
    "lng": 127.039411
  },
  {
    "lat": 37.468587,
    "lng": 127.03976
  },
  {
    "lat": 37.468406,
    "lng": 127.039909
  },
  {
    "lat": 37.468136,
    "lng": 127.04018
  },
  {
    "lat": 37.467463,
    "lng": 127.040914
  },
  {
    "lat": 37.467169,
    "lng": 127.041139
  },
  {
    "lat": 37.466084,
    "lng": 127.042325
  },
  {
    "lat": 37.465738,
    "lng": 127.04265
  },
  {
    "lat": 37.465705,
    "lng": 127.042681
  },
  {
    "lat": 37.46565,
    "lng": 127.042745
  },
  {
    "lat": 37.465619,
    "lng": 127.042702
  },
  {
    "lat": 37.465406,
    "lng": 127.042408
  },
  {
    "lat": 37.465235,
    "lng": 127.042165
  },
  {
    "lat": 37.465115,
    "lng": 127.04201
  },
  {
    "lat": 37.465033,
    "lng": 127.041891
  },
  {
    "lat": 37.464836,
    "lng": 127.041646
  },
  {
    "lat": 37.464167,
    "lng": 127.040722
  },
  {
    "lat": 37.463905,
    "lng": 127.040275
  },
  {
    "lat": 37.463329,
    "lng": 127.039378
  },
  {
    "lat": 37.462316,
    "lng": 127.037979
  },
  {
    "lat": 37.462176,
    "lng": 127.037785
  },
  {
    "lat": 37.461718,
    "lng": 127.037153
  },
  {
    "lat": 37.460949,
    "lng": 127.036119
  },
  {
    "lat": 37.46082,
    "lng": 127.035947
  },
  {
    "lat": 37.460486,
    "lng": 127.035442
  },
  {
    "lat": 37.460289,
    "lng": 127.034962
  },
  {
    "lat": 37.460137,
    "lng": 127.034572
  },
  {
    "lat": 37.460063,
    "lng": 127.034191
  },
  {
    "lat": 37.46003,
    "lng": 127.033707
  },
  {
    "lat": 37.460039,
    "lng": 127.033536
  },
  {
    "lat": 37.460066,
    "lng": 127.032961
  },
  {
    "lat": 37.460179,
    "lng": 127.031009
  },
  {
    "lat": 37.460211,
    "lng": 127.030702
  },
  {
    "lat": 37.460282,
    "lng": 127.030159
  },
  {
    "lat": 37.460398,
    "lng": 127.027958
  },
  {
    "lat": 37.460396,
    "lng": 127.027823
  },
  {
    "lat": 37.460367,
    "lng": 127.027044
  },
  {
    "lat": 37.460368,
    "lng": 127.026832
  },
  {
    "lat": 37.460339,
    "lng": 127.024491
  },
  {
    "lat": 37.460399,
    "lng": 127.023257
  },
  {
    "lat": 37.460433,
    "lng": 127.022577
  },
  {
    "lat": 37.460463,
    "lng": 127.022043
  },
  {
    "lat": 37.460465,
    "lng": 127.02183
  },
  {
    "lat": 37.460464,
    "lng": 127.021441
  },
  {
    "lat": 37.460453,
    "lng": 127.021066
  },
  {
    "lat": 37.460451,
    "lng": 127.021008
  },
  {
    "lat": 37.460383,
    "lng": 127.020602
  },
  {
    "lat": 37.460283,
    "lng": 127.020147
  },
  {
    "lat": 37.460158,
    "lng": 127.020046
  },
  {
    "lat": 37.460101,
    "lng": 127.020006
  },
  {
    "lat": 37.460047,
    "lng": 127.019974
  },
  {
    "lat": 37.460008,
    "lng": 127.01996
  },
  {
    "lat": 37.459968,
    "lng": 127.019953
  },
  {
    "lat": 37.459925,
    "lng": 127.019951
  },
  {
    "lat": 37.459873,
    "lng": 127.019957
  },
  {
    "lat": 37.4598,
    "lng": 127.019989
  },
  {
    "lat": 37.459514,
    "lng": 127.020194
  },
  {
    "lat": 37.458869,
    "lng": 127.020765
  },
  {
    "lat": 37.458439,
    "lng": 127.021007
  },
  {
    "lat": 37.458033,
    "lng": 127.021096
  },
  {
    "lat": 37.457638,
    "lng": 127.021114
  },
  {
    "lat": 37.457317,
    "lng": 127.021088
  },
  {
    "lat": 37.457022,
    "lng": 127.021028
  },
  {
    "lat": 37.456811,
    "lng": 127.020973
  },
  {
    "lat": 37.45657,
    "lng": 127.020886
  },
  {
    "lat": 37.456372,
    "lng": 127.020802
  },
  {
    "lat": 37.456181,
    "lng": 127.020697
  },
  {
    "lat": 37.455996,
    "lng": 127.020587
  },
  {
    "lat": 37.455785,
    "lng": 127.020431
  },
  {
    "lat": 37.455553,
    "lng": 127.020244
  },
  {
    "lat": 37.455387,
    "lng": 127.02009
  },
  {
    "lat": 37.455195,
    "lng": 127.019881
  },
  {
    "lat": 37.45499,
    "lng": 127.019616
  },
  {
    "lat": 37.454825,
    "lng": 127.01935
  },
  {
    "lat": 37.454561,
    "lng": 127.018867
  },
  {
    "lat": 37.454335,
    "lng": 127.018328
  },
  {
    "lat": 37.450615,
    "lng": 127.008392
  },
  {
    "lat": 37.450366,
    "lng": 127.007849
  },
  {
    "lat": 37.450132,
    "lng": 127.007451
  },
  {
    "lat": 37.449918,
    "lng": 127.007128
  },
  {
    "lat": 37.449596,
    "lng": 127.006736
  },
  {
    "lat": 37.449373,
    "lng": 127.0065
  },
  {
    "lat": 37.449137,
    "lng": 127.006286
  },
  {
    "lat": 37.448746,
    "lng": 127.005958
  },
  {
    "lat": 37.448484,
    "lng": 127.00579
  },
  {
    "lat": 37.448223,
    "lng": 127.005633
  },
  {
    "lat": 37.446937,
    "lng": 127.004937
  },
  {
    "lat": 37.442853,
    "lng": 127.00272
  },
  {
    "lat": 37.441654,
    "lng": 127.002083
  },
  {
    "lat": 37.440741,
    "lng": 127.001575
  },
  {
    "lat": 37.439717,
    "lng": 127.001016
  },
  {
    "lat": 37.439417,
    "lng": 127.000905
  },
  {
    "lat": 37.439036,
    "lng": 127.000772
  },
  {
    "lat": 37.438351,
    "lng": 127.000685
  },
  {
    "lat": 37.437801,
    "lng": 127.000708
  },
  {
    "lat": 37.437504,
    "lng": 127.000775
  },
  {
    "lat": 37.436786,
    "lng": 127.001105
  },
  {
    "lat": 37.436631,
    "lng": 127.001192
  },
  {
    "lat": 37.434577,
    "lng": 127.002252
  },
  {
    "lat": 37.434066,
    "lng": 127.002497
  },
  {
    "lat": 37.433857,
    "lng": 127.002514
  },
  {
    "lat": 37.43358,
    "lng": 127.002582
  },
  {
    "lat": 37.433224,
    "lng": 127.002605
  },
  {
    "lat": 37.432963,
    "lng": 127.002608
  },
  {
    "lat": 37.43273,
    "lng": 127.002588
  },
  {
    "lat": 37.432496,
    "lng": 127.00255
  },
  {
    "lat": 37.432232,
    "lng": 127.002487
  },
  {
    "lat": 37.431947,
    "lng": 127.002388
  },
  {
    "lat": 37.431368,
    "lng": 127.002128
  },
  {
    "lat": 37.429824,
    "lng": 127.001441
  },
  {
    "lat": 37.429546,
    "lng": 127.001265
  },
  {
    "lat": 37.428683,
    "lng": 127.000879
  },
  {
    "lat": 37.427247,
    "lng": 127.000206
  },
  {
    "lat": 37.426843,
    "lng": 126.999999
  },
  {
    "lat": 37.426164,
    "lng": 126.9996
  },
  {
    "lat": 37.425605,
    "lng": 126.99922
  },
  {
    "lat": 37.424984,
    "lng": 126.998788
  },
  {
    "lat": 37.423803,
    "lng": 126.9978
  },
  {
    "lat": 37.423625,
    "lng": 126.997646
  },
  {
    "lat": 37.42323,
    "lng": 126.997303
  },
  {
    "lat": 37.422139,
    "lng": 126.996374
  },
  {
    "lat": 37.421844,
    "lng": 126.996106
  },
  {
    "lat": 37.420994,
    "lng": 126.995357
  },
  {
    "lat": 37.420496,
    "lng": 126.994937
  },
  {
    "lat": 37.418788,
    "lng": 126.993551
  },
  {
    "lat": 37.417877,
    "lng": 126.992748
  },
  {
    "lat": 37.417295,
    "lng": 126.992327
  },
  {
    "lat": 37.416554,
    "lng": 126.991902
  },
  {
    "lat": 37.416244,
    "lng": 126.991755
  },
  {
    "lat": 37.415985,
    "lng": 126.991664
  },
  {
    "lat": 37.415726,
    "lng": 126.991589
  },
  {
    "lat": 37.414609,
    "lng": 126.991519
  },
  {
    "lat": 37.414281,
    "lng": 126.991591
  },
  {
    "lat": 37.413958,
    "lng": 126.991679
  },
  {
    "lat": 37.413189,
    "lng": 126.991964
  },
  {
    "lat": 37.412816,
    "lng": 126.992029
  },
  {
    "lat": 37.412383,
    "lng": 126.992165
  },
  {
    "lat": 37.412055,
    "lng": 126.992291
  },
  {
    "lat": 37.411233,
    "lng": 126.992688
  },
  {
    "lat": 37.41059,
    "lng": 126.993051
  },
  {
    "lat": 37.409948,
    "lng": 126.993485
  },
  {
    "lat": 37.409612,
    "lng": 126.993719
  },
  {
    "lat": 37.408602,
    "lng": 126.994468
  },
  {
    "lat": 37.408026,
    "lng": 126.994948
  },
  {
    "lat": 37.407346,
    "lng": 126.995526
  },
  {
    "lat": 37.401784,
    "lng": 127.000598
  },
  {
    "lat": 37.40076,
    "lng": 127.001535
  },
  {
    "lat": 37.40015,
    "lng": 127.002232
  },
  {
    "lat": 37.399679,
    "lng": 127.00272
  },
  {
    "lat": 37.398994,
    "lng": 127.003216
  },
  {
    "lat": 37.39871,
    "lng": 127.003431
  },
  {
    "lat": 37.398028,
    "lng": 127.003786
  },
  {
    "lat": 37.39733,
    "lng": 127.004013
  },
  {
    "lat": 37.396592,
    "lng": 127.004027
  },
  {
    "lat": 37.396414,
    "lng": 127.004032
  },
  {
    "lat": 37.395513,
    "lng": 127.004
  },
  {
    "lat": 37.39503,
    "lng": 127.003946
  },
  {
    "lat": 37.394635,
    "lng": 127.003863
  },
  {
    "lat": 37.394194,
    "lng": 127.003733
  },
  {
    "lat": 37.392773,
    "lng": 127.003203
  },
  {
    "lat": 37.391786,
    "lng": 127.00282
  },
  {
    "lat": 37.391143,
    "lng": 127.002494
  },
  {
    "lat": 37.390397,
    "lng": 127.002056
  },
  {
    "lat": 37.389461,
    "lng": 127.001514
  },
  {
    "lat": 37.388889,
    "lng": 127.001246
  },
  {
    "lat": 37.38675,
    "lng": 127.000273
  },
  {
    "lat": 37.386254,
    "lng": 127.000057
  },
  {
    "lat": 37.385701,
    "lng": 126.999868
  },
  {
    "lat": 37.384992,
    "lng": 126.999722
  },
  {
    "lat": 37.38421,
    "lng": 126.999606
  },
  {
    "lat": 37.383063,
    "lng": 126.999431
  },
  {
    "lat": 37.38234,
    "lng": 126.999278
  },
  {
    "lat": 37.381262,
    "lng": 126.99897
  },
  {
    "lat": 37.379767,
    "lng": 126.998471
  },
  {
    "lat": 37.37899,
    "lng": 126.998249
  },
  {
    "lat": 37.377953,
    "lng": 126.997905
  },
  {
    "lat": 37.377184,
    "lng": 126.997735
  },
  {
    "lat": 37.376666,
    "lng": 126.997678
  },
  {
    "lat": 37.375876,
    "lng": 126.99751
  },
  {
    "lat": 37.374917,
    "lng": 126.997429
  },
  {
    "lat": 37.373572,
    "lng": 126.997435
  },
  {
    "lat": 37.372882,
    "lng": 126.997489
  },
  {
    "lat": 37.372236,
    "lng": 126.997579
  },
  {
    "lat": 37.37146,
    "lng": 126.99774
  },
  {
    "lat": 37.370641,
    "lng": 126.997965
  },
  {
    "lat": 37.369608,
    "lng": 126.998313
  },
  {
    "lat": 37.369058,
    "lng": 126.998397
  },
  {
    "lat": 37.368606,
    "lng": 126.998498
  },
  {
    "lat": 37.36845,
    "lng": 126.998543
  },
  {
    "lat": 37.368307,
    "lng": 126.998577
  },
  {
    "lat": 37.367727,
    "lng": 126.998702
  },
  {
    "lat": 37.367155,
    "lng": 126.998775
  },
  {
    "lat": 37.36634,
    "lng": 126.99888
  },
  {
    "lat": 37.365603,
    "lng": 126.998945
  },
  {
    "lat": 37.364916,
    "lng": 126.998964
  },
  {
    "lat": 37.363666,
    "lng": 126.998998
  },
  {
    "lat": 37.362114,
    "lng": 126.99875
  },
  {
    "lat": 37.360711,
    "lng": 126.998215
  },
  {
    "lat": 37.359936,
    "lng": 126.997832
  },
  {
    "lat": 37.358924,
    "lng": 126.997235
  },
  {
    "lat": 37.358148,
    "lng": 126.996595
  },
  {
    "lat": 37.357297,
    "lng": 126.995831
  },
  {
    "lat": 37.356637,
    "lng": 126.995144
  },
  {
    "lat": 37.356003,
    "lng": 126.994343
  },
  {
    "lat": 37.355455,
    "lng": 126.993676
  },
  {
    "lat": 37.354851,
    "lng": 126.9927
  },
  {
    "lat": 37.354075,
    "lng": 126.991372
  },
  {
    "lat": 37.353517,
    "lng": 126.990569
  },
  {
    "lat": 37.352884,
    "lng": 126.989761
  },
  {
    "lat": 37.352059,
    "lng": 126.988891
  },
  {
    "lat": 37.350814,
    "lng": 126.987657
  },
  {
    "lat": 37.350351,
    "lng": 126.987168
  },
  {
    "lat": 37.34755,
    "lng": 126.984309
  },
  {
    "lat": 37.346389,
    "lng": 126.983276
  },
  {
    "lat": 37.346113,
    "lng": 126.982992
  },
  {
    "lat": 37.346013,
    "lng": 126.982889
  },
  {
    "lat": 37.345486,
    "lng": 126.982365
  },
  {
    "lat": 37.344922,
    "lng": 126.981797
  },
  {
    "lat": 37.344773,
    "lng": 126.981653
  },
  {
    "lat": 37.343347,
    "lng": 126.980225
  },
  {
    "lat": 37.342831,
    "lng": 126.9797
  },
  {
    "lat": 37.341961,
    "lng": 126.978839
  },
  {
    "lat": 37.338423,
    "lng": 126.975222
  },
  {
    "lat": 37.33743,
    "lng": 126.974076
  },
  {
    "lat": 37.336782,
    "lng": 126.973285
  },
  {
    "lat": 37.336346,
    "lng": 126.97271
  },
  {
    "lat": 37.335558,
    "lng": 126.971663
  },
  {
    "lat": 37.334794,
    "lng": 126.970628
  },
  {
    "lat": 37.334319,
    "lng": 126.970012
  },
  {
    "lat": 37.333769,
    "lng": 126.969363
  },
  {
    "lat": 37.333285,
    "lng": 126.968874
  },
  {
    "lat": 37.332782,
    "lng": 126.9684
  },
  {
    "lat": 37.332415,
    "lng": 126.968074
  },
  {
    "lat": 37.331964,
    "lng": 126.967684
  },
  {
    "lat": 37.331524,
    "lng": 126.967367
  },
  {
    "lat": 37.331064,
    "lng": 126.967041
  },
  {
    "lat": 37.330153,
    "lng": 126.966547
  },
  {
    "lat": 37.329684,
    "lng": 126.96631
  },
  {
    "lat": 37.329139,
    "lng": 126.966056
  },
  {
    "lat": 37.328353,
    "lng": 126.965774
  },
  {
    "lat": 37.327511,
    "lng": 126.965556
  },
  {
    "lat": 37.327152,
    "lng": 126.965484
  },
  {
    "lat": 37.326705,
    "lng": 126.965414
  },
  {
    "lat": 37.326257,
    "lng": 126.965369
  },
  {
    "lat": 37.32525,
    "lng": 126.965335
  },
  {
    "lat": 37.324477,
    "lng": 126.965375
  },
  {
    "lat": 37.322711,
    "lng": 126.965551
  },
  {
    "lat": 37.321654,
    "lng": 126.965689
  },
  {
    "lat": 37.320897,
    "lng": 126.965808
  },
  {
    "lat": 37.320098,
    "lng": 126.965922
  },
  {
    "lat": 37.319489,
    "lng": 126.966
  },
  {
    "lat": 37.317269,
    "lng": 126.966291
  },
  {
    "lat": 37.317127,
    "lng": 126.966308
  },
  {
    "lat": 37.316986,
    "lng": 126.966323
  },
  {
    "lat": 37.315866,
    "lng": 126.966444
  },
  {
    "lat": 37.313944,
    "lng": 126.966586
  },
  {
    "lat": 37.312732,
    "lng": 126.966646
  },
  {
    "lat": 37.311774,
    "lng": 126.96667
  },
  {
    "lat": 37.310929,
    "lng": 126.966665
  },
  {
    "lat": 37.310164,
    "lng": 126.966603
  },
  {
    "lat": 37.309397,
    "lng": 126.966467
  },
  {
    "lat": 37.308929,
    "lng": 126.966368
  },
  {
    "lat": 37.308475,
    "lng": 126.966236
  },
  {
    "lat": 37.307656,
    "lng": 126.965932
  },
  {
    "lat": 37.306898,
    "lng": 126.965564
  },
  {
    "lat": 37.30656,
    "lng": 126.965385
  },
  {
    "lat": 37.306157,
    "lng": 126.965162
  },
  {
    "lat": 37.305202,
    "lng": 126.964522
  },
  {
    "lat": 37.30448,
    "lng": 126.963925
  },
  {
    "lat": 37.303903,
    "lng": 126.96336
  },
  {
    "lat": 37.30343,
    "lng": 126.962851
  },
  {
    "lat": 37.303186,
    "lng": 126.962538
  },
  {
    "lat": 37.302862,
    "lng": 126.962133
  },
  {
    "lat": 37.301459,
    "lng": 126.960252
  },
  {
    "lat": 37.3006,
    "lng": 126.95904
  },
  {
    "lat": 37.29967,
    "lng": 126.957791
  },
  {
    "lat": 37.299228,
    "lng": 126.957227
  },
  {
    "lat": 37.29864,
    "lng": 126.956559
  },
  {
    "lat": 37.298163,
    "lng": 126.956012
  },
  {
    "lat": 37.297488,
    "lng": 126.955361
  },
  {
    "lat": 37.29659,
    "lng": 126.954568
  },
  {
    "lat": 37.295673,
    "lng": 126.95384
  },
  {
    "lat": 37.294743,
    "lng": 126.953194
  },
  {
    "lat": 37.293952,
    "lng": 126.952691
  },
  {
    "lat": 37.293432,
    "lng": 126.952394
  },
  {
    "lat": 37.292542,
    "lng": 126.951933
  },
  {
    "lat": 37.291668,
    "lng": 126.951547
  },
  {
    "lat": 37.291165,
    "lng": 126.951345
  },
  {
    "lat": 37.290753,
    "lng": 126.9512
  },
  {
    "lat": 37.290022,
    "lng": 126.950962
  },
  {
    "lat": 37.289471,
    "lng": 126.9508
  },
  {
    "lat": 37.289145,
    "lng": 126.950716
  },
  {
    "lat": 37.288015,
    "lng": 126.950504
  },
  {
    "lat": 37.287484,
    "lng": 126.950432
  },
  {
    "lat": 37.287216,
    "lng": 126.950392
  },
  {
    "lat": 37.286851,
    "lng": 126.950342
  },
  {
    "lat": 37.28627,
    "lng": 126.950311
  },
  {
    "lat": 37.285376,
    "lng": 126.950285
  },
  {
    "lat": 37.284477,
    "lng": 126.950308
  },
  {
    "lat": 37.282869,
    "lng": 126.95037
  },
  {
    "lat": 37.281105,
    "lng": 126.950407
  },
  {
    "lat": 37.280052,
    "lng": 126.950395
  },
  {
    "lat": 37.278952,
    "lng": 126.950344
  },
  {
    "lat": 37.277995,
    "lng": 126.950267
  },
  {
    "lat": 37.277191,
    "lng": 126.950181
  },
  {
    "lat": 37.276341,
    "lng": 126.950071
  },
  {
    "lat": 37.276291,
    "lng": 126.950064
  },
  {
    "lat": 37.276133,
    "lng": 126.950046
  },
  {
    "lat": 37.275079,
    "lng": 126.949923
  },
  {
    "lat": 37.274594,
    "lng": 126.949859
  },
  {
    "lat": 37.274127,
    "lng": 126.949796
  },
  {
    "lat": 37.273338,
    "lng": 126.949693
  },
  {
    "lat": 37.271702,
    "lng": 126.949456
  },
  {
    "lat": 37.270481,
    "lng": 126.949293
  },
  {
    "lat": 37.270223,
    "lng": 126.949251
  },
  {
    "lat": 37.269045,
    "lng": 126.949057
  },
  {
    "lat": 37.268145,
    "lng": 126.94894
  },
  {
    "lat": 37.266621,
    "lng": 126.948753
  },
  {
    "lat": 37.266219,
    "lng": 126.948709
  },
  {
    "lat": 37.265208,
    "lng": 126.948549
  },
  {
    "lat": 37.264438,
    "lng": 126.948459
  },
  {
    "lat": 37.263178,
    "lng": 126.948345
  },
  {
    "lat": 37.262508,
    "lng": 126.948328
  },
  {
    "lat": 37.26222,
    "lng": 126.948315
  },
  {
    "lat": 37.261917,
    "lng": 126.948313
  },
  {
    "lat": 37.261222,
    "lng": 126.948346
  },
  {
    "lat": 37.260675,
    "lng": 126.948395
  },
  {
    "lat": 37.259358,
    "lng": 126.948577
  },
  {
    "lat": 37.256138,
    "lng": 126.948916
  },
  {
    "lat": 37.255074,
    "lng": 126.949018
  },
  {
    "lat": 37.254566,
    "lng": 126.949062
  },
  {
    "lat": 37.25347,
    "lng": 126.94921
  },
  {
    "lat": 37.252383,
    "lng": 126.949209
  },
  {
    "lat": 37.251237,
    "lng": 126.949349
  },
  {
    "lat": 37.250918,
    "lng": 126.949359
  },
  {
    "lat": 37.24899,
    "lng": 126.949585
  },
  {
    "lat": 37.248142,
    "lng": 126.949534
  },
  {
    "lat": 37.247598,
    "lng": 126.949591
  },
  {
    "lat": 37.246834,
    "lng": 126.949792
  },
  {
    "lat": 37.245946,
    "lng": 126.949864
  },
  {
    "lat": 37.244942,
    "lng": 126.949717
  },
  {
    "lat": 37.244201,
    "lng": 126.949685
  },
  {
    "lat": 37.24405,
    "lng": 126.949668
  },
  {
    "lat": 37.243732,
    "lng": 126.94966
  },
  {
    "lat": 37.243633,
    "lng": 126.949657
  },
  {
    "lat": 37.243627,
    "lng": 126.949733
  },
  {
    "lat": 37.243616,
    "lng": 126.949916
  },
  {
    "lat": 37.243601,
    "lng": 126.950113
  },
  {
    "lat": 37.243582,
    "lng": 126.950392
  },
  {
    "lat": 37.243492,
    "lng": 126.951448
  },
  {
    "lat": 37.243467,
    "lng": 126.9517
  },
  {
    "lat": 37.243341,
    "lng": 126.952983
  },
  {
    "lat": 37.243302,
    "lng": 126.953382
  },
  {
    "lat": 37.243135,
    "lng": 126.955018
  },
  {
    "lat": 37.243079,
    "lng": 126.955139
  },
  {
    "lat": 37.24304,
    "lng": 126.955461
  },
  {
    "lat": 37.242999,
    "lng": 126.955954
  },
  {
    "lat": 37.24299,
    "lng": 126.956454
  },
  {
    "lat": 37.243027,
    "lng": 126.956971
  },
  {
    "lat": 37.243084,
    "lng": 126.95735
  },
  {
    "lat": 37.243129,
    "lng": 126.957588
  },
  {
    "lat": 37.243134,
    "lng": 126.957777
  },
  {
    "lat": 37.243112,
    "lng": 126.957916
  },
  {
    "lat": 37.243003,
    "lng": 126.95805
  },
  {
    "lat": 37.24291,
    "lng": 126.958113
  },
  {
    "lat": 37.242714,
    "lng": 126.958209
  },
  {
    "lat": 37.242642,
    "lng": 126.958229
  },
  {
    "lat": 37.241959,
    "lng": 126.958379
  },
  {
    "lat": 37.241553,
    "lng": 126.958491
  },
  {
    "lat": 37.241108,
    "lng": 126.958727
  },
  {
    "lat": 37.240877,
    "lng": 126.958839
  },
  {
    "lat": 37.238995,
    "lng": 126.960214
  },
  {
    "lat": 37.238265,
    "lng": 126.960784
  },
  {
    "lat": 37.238033,
    "lng": 126.960976
  },
  {
    "lat": 37.237881,
    "lng": 126.961188
  },
  {
    "lat": 37.237814,
    "lng": 126.961305
  },
  {
    "lat": 37.237728,
    "lng": 126.961569
  },
  {
    "lat": 37.237604,
    "lng": 126.962289
  },
  {
    "lat": 37.237434,
    "lng": 126.963191
  },
  {
    "lat": 37.237209,
    "lng": 126.963834
  },
  {
    "lat": 37.23688,
    "lng": 126.96447
  },
  {
    "lat": 37.23665,
    "lng": 126.9649
  },
  {
    "lat": 37.236304,
    "lng": 126.965653
  },
  {
    "lat": 37.235964,
    "lng": 126.966343
  },
  {
    "lat": 37.23571,
    "lng": 126.966794
  },
  {
    "lat": 37.23541,
    "lng": 126.96718
  },
  {
    "lat": 37.23509,
    "lng": 126.96747
  },
  {
    "lat": 37.234869,
    "lng": 126.967601
  },
  {
    "lat": 37.234463,
    "lng": 126.967873
  },
  {
    "lat": 37.234133,
    "lng": 126.968012
  },
  {
    "lat": 37.23277,
    "lng": 126.96853
  },
  {
    "lat": 37.232654,
    "lng": 126.96857
  },
  {
    "lat": 37.231117,
    "lng": 126.969101
  },
  {
    "lat": 37.230728,
    "lng": 126.96924
  },
  {
    "lat": 37.23045,
    "lng": 126.96934
  },
  {
    "lat": 37.230031,
    "lng": 126.96961
  },
  {
    "lat": 37.22967,
    "lng": 126.9699
  },
  {
    "lat": 37.22923,
    "lng": 126.9704
  },
  {
    "lat": 37.228853,
    "lng": 126.970794
  },
  {
    "lat": 37.228808,
    "lng": 126.970836
  },
  {
    "lat": 37.228452,
    "lng": 126.971168
  },
  {
    "lat": 37.228087,
    "lng": 126.971409
  },
  {
    "lat": 37.22764,
    "lng": 126.9716
  },
  {
    "lat": 37.22742,
    "lng": 126.971676
  },
  {
    "lat": 37.22738,
    "lng": 126.97169
  },
  {
    "lat": 37.22709,
    "lng": 126.97177
  },
  {
    "lat": 37.226665,
    "lng": 126.971793
  },
  {
    "lat": 37.226404,
    "lng": 126.971806
  },
  {
    "lat": 37.226317,
    "lng": 126.971818
  },
  {
    "lat": 37.225877,
    "lng": 126.971877
  },
  {
    "lat": 37.22556,
    "lng": 126.97192
  },
  {
    "lat": 37.225432,
    "lng": 126.971952
  },
  {
    "lat": 37.22512,
    "lng": 126.97203
  },
  {
    "lat": 37.22449,
    "lng": 126.9723
  },
  {
    "lat": 37.224129,
    "lng": 126.972572
  },
  {
    "lat": 37.223625,
    "lng": 126.972941
  },
  {
    "lat": 37.223319,
    "lng": 126.973139
  },
  {
    "lat": 37.222166,
    "lng": 126.974003
  },
  {
    "lat": 37.221616,
    "lng": 126.974412
  },
  {
    "lat": 37.221496,
    "lng": 126.974539
  },
  {
    "lat": 37.220209,
    "lng": 126.976144
  },
  {
    "lat": 37.219877,
    "lng": 126.976557
  },
  {
    "lat": 37.219582,
    "lng": 126.976847
  },
  {
    "lat": 37.219229,
    "lng": 126.977101
  },
  {
    "lat": 37.21868,
    "lng": 126.977421
  },
  {
    "lat": 37.217791,
    "lng": 126.977941
  },
  {
    "lat": 37.217417,
    "lng": 126.978159
  },
  {
    "lat": 37.217029,
    "lng": 126.978386
  },
  {
    "lat": 37.216522,
    "lng": 126.978753
  },
  {
    "lat": 37.216291,
    "lng": 126.978911
  },
  {
    "lat": 37.216105,
    "lng": 126.979051
  },
  {
    "lat": 37.215414,
    "lng": 126.979599
  },
  {
    "lat": 37.215214,
    "lng": 126.979758
  },
  {
    "lat": 37.214909,
    "lng": 126.980013
  },
  {
    "lat": 37.214612,
    "lng": 126.980261
  },
  {
    "lat": 37.21443,
    "lng": 126.98045
  },
  {
    "lat": 37.214393,
    "lng": 126.980486
  },
  {
    "lat": 37.213921,
    "lng": 126.979952
  },
  {
    "lat": 37.213877,
    "lng": 126.979887
  },
  {
    "lat": 37.213842,
    "lng": 126.979834
  },
  {
    "lat": 37.213824,
    "lng": 126.979706
  },
  {
    "lat": 37.214223,
    "lng": 126.978863
  },
  {
    "lat": 37.214105,
    "lng": 126.97872
  },
  {
    "lat": 37.213353,
    "lng": 126.978283
  },
  {
    "lat": 37.213155,
    "lng": 126.978204
  },
  {
    "lat": 37.21301,
    "lng": 126.978148
  },
  {
    "lat": 37.212893,
    "lng": 126.978122
  },
  {
    "lat": 37.21247,
    "lng": 126.978027
  },
  {
    "lat": 37.212024,
    "lng": 126.977905
  },
  {
    "lat": 37.211802,
    "lng": 126.977844
  },
  {
    "lat": 37.211408,
    "lng": 126.977566
  },
  {
    "lat": 37.211197,
    "lng": 126.977399
  },
  {
    "lat": 37.210904,
    "lng": 126.977243
  },
  {
    "lat": 37.210071,
    "lng": 126.977118
  }
]

// Keep the provider snapshot immutable; consumers receive copies from the model.
GANGNAM_ROAD_PATH.forEach(Object.freeze)
Object.freeze(GANGNAM_ROAD_PATH)
